import * as types from './mutation-types'
import * as authApi from '@/auth/api'
import api from '@/utils/api'
import {getTrainer, fetchSimpleAdminTrainers} from '@/trainers/api'
import {getRunner, fetchSimpleTrainerRunners, fetchSimpleAdminRunners} from '@/runners/api'
import router from '@/router'

export default {
  [types.AUTH_REQUEST]: ({commit, dispatch}, user) => {
    commit(types.AUTH_REQUEST)
    return new Promise((resolve, reject) => {
      authApi.login(user)
        .then(resp => {
          const token = resp.data.key
          commit(types.AUTH_SUCCESS, token)
          dispatch(types.USER_REQUEST).then(resp => {
            resolve(resp)
          })
        })
        .catch(err => {
          commit(types.AUTH_ERROR, err)
          reject(err)
        })
    })
  },
  [types.AUTH_TOKEN]: ({commit, dispatch}, token) => {
    commit(types.AUTH_SUCCESS, token)
    return dispatch(types.USER_REQUEST)
  },
  [types.AUTH_LOGOUT]: ({commit, dispatch}) => {
    commit(types.AUTH_LOGOUT)
    router.push({name: 'app'})
  },
  [types.USER_REQUEST]: ({commit, dispatch}) => {
    commit(types.USER_REQUEST)
    return authApi.user()
      .then(resp => {
        commit(types.USER_SUCCESS, resp)
        return resp
      })
      .catch(resp => {
        commit(types.USER_ERROR)
        dispatch(types.AUTH_LOGOUT)
      })
  },
  [types.ALL_TRAINERS_REQUEST]: ({commit, dispatch, state}) => {
    if (state.initial.allTrainers.length > 0) {
      return Promise.resolve()
    }
    return api({url: '/trainers/?pagination=false&is_active=true'})
      .then(resp => {
        commit(types.ALL_TRAINERS_SUCCESS, resp)
      })
      .catch(resp => {
      })
  },
  [types.TRAINER_REQUEST]: ({commit, dispatch, state}, trainerId) => {
    if (state.trainer && state.trainer.id === parseInt(trainerId)) {
      return Promise.resolve(state.trainer)
    }
    return getTrainer(trainerId)
      .then(resp => {
        commit(types.TRAINER_SUCCESS, resp)
        return resp
      })
      .catch(resp => {
      })
  },
  [types.RUNNER_REQUEST]: ({commit, dispatch, state, getters}, [runnerId, force]) => {
    if (!force && state.runner && state.runner.id === parseInt(runnerId)) {
      return Promise.resolve(state.runner)
    }
    return getRunner(runnerId).then(resp => {
      commit(types.RUNNER_SUCCESS, resp)
      return resp
    })
      .catch(resp => {
      })
  },
  [types.RUNNERS_TRAINER_REQUEST]: ({commit, dispatch, state}, runner) => {
    if (!runner.trainer) {
      return Promise.resolve(null)
    }
    if (state.runnersTrainer && state.runnersTrainer.id === runner.trainer) {
      return Promise.resolve(state.runnersTrainer)
    }
    return getTrainer(runner.trainer)
      .then(resp => {
        commit(types.RUNNERS_TRAINER_SUCCESS, resp)
        return resp
      })
      .catch(resp => {
      })
  },

  [types.TRAINERS_RUNNERS_REQUEST]: ({commit, dispatch, state}, trainer) => {
    if (state.trainerRunners.length > 0 && state.trainerRunners[0].trainer === trainer.id) {
      return Promise.resolve(state.trainerRunners)
    }
    return fetchSimpleTrainerRunners(trainer.id)
      .then(resp => {
        commit(types.TRAINERS_RUNNERS_SUCCESS, resp)
        return resp
      })
      .catch(resp => {
      })
  },
  [types.ADMIN_RUNNERS_REQUEST]: ({commit, dispatch, state}) => {
    if (state.adminRunners.length > 0) {
      return Promise.resolve(state.adminRunners)
    }
    return fetchSimpleAdminRunners()
      .then(resp => {
        commit(types.ADMIN_RUNNERS_SUCCESS, resp)
        return resp
      })
      .catch(resp => {
      })
  },
  [types.ADMIN_TRAINERS_REQUEST]: ({commit, dispatch, state}) => {
    if (state.adminTrainers.length > 0) {
      return Promise.resolve(state.adminTrainers)
    }
    return fetchSimpleAdminTrainers()
      .then(resp => {
        commit(types.ADMIN_TRAINERS_SUCCESS, resp)
        return resp
      })
      .catch(resp => {
      })
  },
  [types.ALL_PACKAGES_REQUEST]: ({commit, dispatch, state}) => {
    if (state.initial.allPackages.length > 0) {
      return Promise.resolve()
    }
    return api({url: '/packages/?pagination=false&is_active=true'})
      .then(resp => {
        commit(types.ALL_PACKAGES_SUCCESS, resp)
      })
      .catch(resp => {
      })
  },
  [types.ALL_WORKOUTS_TEMPLATES_REQUEST]: ({commit, dispatch, state}, force = false) => {
    if (state.initial.allWorkoutsTemplates.length > 0 && !force) {
      return Promise.resolve()
    }
    return api({url: '/workouts_templates/'})
      .then(resp => {
        commit(types.ALL_WORKOUTS_TEMPLATES_SUCCESS, resp)
      })
      .catch(resp => {
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js